var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.24 8.58333C8.424 8.09167 7.84 7.58333 7.84 6.79167C7.84 5.88333 8.648 5.25 10 5.25C11.136 5.25 11.704 5.7 11.912 6.41667C12.008 6.75 12.272 7 12.608 7H12.848C13.376 7 13.752 6.45833 13.568 5.94167C13.232 4.95833 12.448 4.14167 11.2 3.825V3.25C11.2 2.55833 10.664 2 10 2C9.336 2 8.8 2.55833 8.8 3.25V3.8C7.248 4.15 6 5.2 6 6.80833C6 8.73333 7.528 9.69167 9.76 10.25C11.76 10.75 12.16 11.4833 12.16 12.2583C12.16 12.8333 11.768 13.75 10 13.75C8.68 13.75 8 13.2583 7.736 12.5583C7.616 12.2333 7.344 12 7.016 12H6.792C6.256 12 5.88 12.5667 6.08 13.0833C6.536 14.2417 7.6 14.925 8.8 15.1917V15.75C8.8 16.4417 9.336 17 10 17C10.664 17 11.2 16.4417 11.2 15.75V15.2083C12.76 14.9 14 13.9583 14 12.25C14 9.88333 12.056 9.075 10.24 8.58333Z",
    fill: "#1D7E7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.f9ff805f70e5887ef5216072dbba17e7.svg";
export { ForwardRef as ReactComponent };